// extracted by mini-css-extract-plugin
module.exports = {"copy":"footer-module--copy--OmIUw","socialList":"footer-module--socialList--1PFRz","socialLine":"footer-module--socialLine--33t_u"};